import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthInterceptorService } from '../../core/auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChartsModule } from '@progress/kendo-angular-charts';
import {RuleService} from '../../rules/service/rule.service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { RulePropertiesComponent } from '../RuleProperties/ruleproperties.component';
import { DragulaModule } from 'ng2-dragula';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  bootstrap: [
    RulePropertiesComponent
  ],
  imports: [FormsModule, 
    CommonModule,
    ChartsModule,
    LayoutModule,
    GridModule,
    TreeViewModule,
    DialogModule,
    DragulaModule.forRoot(),
    InputsModule,
    NgSelectModule
  ],
  declarations: [
    RulePropertiesComponent
  ],
  exports:[CommonModule,FormsModule,RulePropertiesComponent,NgSelectModule ],
  providers: [
    RuleService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
  ]
})
export class RPropertiesModule {}

